import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Chips } from '@cian/ui-kit';

import { constructionStatusDescriptors } from '../../constants/descriptors';
import { isDescriptorActive } from '../../utils/filters';
import { IApplicationState } from '../../types/redux';
import { TTypedThunkDispatch } from '../../types/thunk';
import { getOffersCount } from '../../actions/offersData';
import { updateTags } from '../../actions/filterTags';
import { ECompletionYearType, CURRENT_YEAR } from '../../constants/avaliableYears';
import { EFiltersActions } from '../../actions/filters';

export const ConstructionStatus: React.FC = React.memo(() => {
  const dispatch = useDispatch<TTypedThunkDispatch>();
  const jsonQuery = useSelector((state: IApplicationState) => state.jsonQuery);

  const options = React.useMemo(
    () =>
      constructionStatusDescriptors.map(({ state, label }) => ({
        label,
        value: state,
      })),
    [],
  );

  const activeDescriptors = React.useMemo(
    () => constructionStatusDescriptors.filter(descriptor => isDescriptorActive(descriptor)(jsonQuery)),
    [jsonQuery],
  );

  const currentValues = React.useMemo(() => activeDescriptors.map(d => d.state), [activeDescriptors]);

  const handleChipClick = React.useCallback(
    (value: string) => {
      const descriptor = constructionStatusDescriptors.find(d => d.state === value);

      if (descriptor) {
        // Проверяем, активен ли дескриптор
        const isActive = activeDescriptors.some(d => d.state === value);

        // Если это "Дом сдан" или "2030 и позже" и они уже активны, диспатчим clear action
        if (value === String(ECompletionYearType.HandedOver) && isActive) {
          dispatch({
            type: EFiltersActions.clear,
            key: 'is_finished',
            value: true,
          });
        } else if (value === String(ECompletionYearType.Later) && isActive) {
          dispatch({
            type: EFiltersActions.clear,
            key: 'yeargte',
            value: CURRENT_YEAR + ECompletionYearType.Later,
          });
        } else {
          dispatch({
            type: `${descriptor.name}/${descriptor.state}`,
            value,
          });
        }
        dispatch(updateTags());
        dispatch(getOffersCount());
      }
    },
    [dispatch, activeDescriptors],
  );

  return <Chips options={options} size="M" value={currentValues} selectType="multiple" onChipClick={handleChipClick} />;
});

ConstructionStatus.displayName = 'ConstructionStatus';
